export const companyViewModes = {
  selfRegistering: 'selfRegistering',
  ipermitInvite: 'ipermitInvite',
  existingCompany: 'existingCompany',
  verifyCompany: 'verifyCompany',
  completeOnboarding: 'completeOnboarding',
  general: 'general'
};
